export default "__VITE_ASSET__c459f7ee__"